module.exports = {
      id: "recharge-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "images/sprites/poi.svg#recharge-usage",
      toString: function () {
        return this.url;
      }
    }